module.exports = __webpack_public_path__ + "static/media/aZRX-logo.ecb77c87.png";